import React from 'react'
import withFeature from 'components/withFeature'
import updateFeatureMutation from 'graphs/mutations/updateFeature.graphql'
import CurrentUserQuery from 'graphs/queries/CurrentUser.graphql'
import FormForRecord from 'components/FormForRecord'
import fields from 'fields/features'

const RouteEdit = ({ feature, history: { goBack } }) => (
  <FormForRecord
    record={feature}
    mutation={updateFeatureMutation}
    mutationArgs={{
      refetchQueries: [
        {
          query: CurrentUserQuery
        }
      ]
    }}
    onSuccess={goBack}
    onCancel={goBack}
    fields={fields}
    variables={{ id: feature.id }}
    title={`Edit Feature Flag ${feature.id}`}
  />
)

export default withFeature(RouteEdit)



// WEBPACK FOOTER //
// ./src/routes/admin/features/edit.js